module.exports = __webpack_public_path__ + "static/media/6.40408025.png";